import { call, put, takeLatest } from 'redux-saga/effects';
import { Creators, Types } from '../../redux/document/actions';
import { history } from '../../../utils/helpers';
import {
  uploadDocument as uploadDocumentApi
} from '../../api/document';
import _ from 'lodash';

export function* uploadDocument(actions) {
  try {
    const { payload, requestId } = actions;
    const responseData = yield call(uploadDocumentApi, payload, requestId);
    yield put(Creators.uploadDocumentSuccess(_.get(responseData, 'data.response.request_id')));
    history.push('/extend/Finish');
  } catch (error) {
    let error_message = error && error.response.data.errors;
    yield put(Creators.uploadDocumentFailure(error_message));
  }
}

export function* watchUploadDocument() {
  yield takeLatest(Types.UPLOAD_DOCUMENT, uploadDocument);
}

